import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";

import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";


import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
import RichTextEditor from "../../Components/RichTextEditor";
import AddAgreementNote from "./AddAgreementNote";
import { getDateString } from "../../config/functions";
const { Option } = Select;


const AgreementNotes = () => {


    const ids = useParams();
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const user = useSelector((state) => state.authReducer.user);
    const [agreementNotes, setAgreementNotes] = useState([]);
    const [agreementInfo, setAgreementInfo] = useState({});
    const [isAddNote, setIsAddNote] = useState('');

    const getAgreementNotes = async (value) => {

        const onSuccess = (res) => {

            setAgreementNotes(res.data);
            setAgreementInfo(res.agreement_data);
            dispatch(setLoader(false));
        }

        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            agreement_id: ids.id,
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getAgreementNotes, onSuccess, onError);
    }


    const updateNote = async (value, note_id, cb) => {

        const onSuccess = () => {
            dispatch(setLoader(false));
            message.success('Note saved!');
            navigate(`/agreement-notes/${ids.id}`);
            cb();
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.updateAgreementNote, onSuccess, onError);


    }

    const deleteNote = async (note_id) => {

        const onSuccess = (res) => {
            dispatch(setLoader(false));
            message.success('Note deleted!');
            setAgreementNotes(res.agreement_notes)

        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to delete note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            agreement_id:ids.id
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.deleteAgreementNote, onSuccess, onError);


    }


    const saveNote = async (value) => {

        const onSuccess = (res) => {
            // dispatch(setLoader(false));
            setIsAddNote(false);
            setAgreementNotes(res.agreement_notes)
            message.success('Note saved!');

            // navigate(`/agreement-notes/${ids.id}`);
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            agreement_id: ids.id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addAgreementNote, onSuccess, onError);


    }






    useEffect(() => {
        getAgreementNotes();
    }, [])




    const RenderAgreements = React.useCallback(
      () => {
        {
            return agreementNotes?.map((v, i) => {
                return (
                    <div style={{ width: "100%", }}>
                        <Typography style={{ color: appColors.black, fontSize: 16, fontFamily: 'Poppins', marginLeft: 10, marginTop: 20 }}>Created at: {new Date(v.created_at).toLocaleString()}</Typography>

                        <RichTextEditor
                            disabled={true}
                            val={v.note}
                            data={v}
                            edit={true}
                            del={true}
                            onSave={(value, cb = () => { }) => updateNote(value, v.an_id, cb)}
                            onDelete={() => deleteNote(v.an_id)}
                        />
                    </div>
                )
            })
        }
      },
      [agreementNotes],
    )
    


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Agreement notes
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Agreement information</Typography>
                            </div>

                            <div style={{ display: 'flex', width: "98%", borderRadius: 5, flexDirection: 'row', padding: 5, paddingTop: 10, backgroundColor: 'white', marginTop: 20, paddingLeft: 20, flexWrap: 'wrap' }} >

                                <div style={{ marginLeft:0, display: 'flex', flexDirection: 'column', minWidth: "80%", maxWidth: "100%", overflowY: 'auto' }}>
                                    <div style={vehicleRowContainer}>
                                        <div style={vehicleRow1}>
                                            <Typography sx={fieldText} >Vehicle Name</Typography>
                                            <Typography sx={valueText} >{agreementInfo.veh_name}</Typography>
                                        </div>
                                        <div style={vehicleRow2}>
                                            <Typography sx={fieldText} >Reg no</Typography>
                                            <Typography sx={valueText} >{agreementInfo.reg_no}</Typography>
                                        </div>
                                        <div style={vehicleRow1}>
                                            <Typography sx={fieldText} ></Typography>
                                            <Typography sx={valueText} ></Typography>
                                        </div>
                                    </div>
                                    <div style={vehicleRowContainer}>
                                        <div style={vehicleRow1}>
                                            <Typography sx={fieldText} >Cust name</Typography>
                                            <Typography sx={valueText} >{agreementInfo.name}</Typography>
                                        </div>
                                        <div style={vehicleRow2}>
                                            <Typography sx={fieldText} >Cust email</Typography>
                                            <Typography sx={valueText} >{agreementInfo.email}</Typography>
                                        </div>
                                        <div style={vehicleRow1}>
                                            <Typography sx={fieldText} >Cust phone</Typography>
                                            <Typography sx={valueText} >{agreementInfo.phone}</Typography>
                                        </div>

                                    </div>



                                </div>

                            </div>




                        </div>

                        
                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Notes</Typography>
                                <div
                                    onClick={() => setIsAddNote(!isAddNote)}
                                    style={{ cursor: 'pointer', height: 20, alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: 5, borderRadius: 50, marginRight: 10 }}>
                                    {
                                        isAddNote ?
                                            <RemoveIcon />
                                            :
                                            <AddIcon style={{ color: appColors.primary, fontSize: 24 }} />
                                    }
                                </div>
                            </div>
                            {
                                isAddNote &&
                                <div style={{ borderWidth: 1, borderStyle: 'solid', width: "99%", marginTop: 10, display: 'flex', alignSelf: 'center', flexDirection: 'column', borderColor: appColors.greyText }}>
                                    <div style={{ display: 'flex', marginTop: 10, marginBottom: 5, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                        Add new note
                                    </div>
                                    <RichTextEditor
                                        submitButtonText="Add note"
                                        onSave={(value) => saveNote(value)}
                                    />
                                </div>
                            }
                            {
                                !agreementNotes?.length &&
                                <div style={{ display: 'flex', marginTop: 20, marginBottom: 10, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                    You have no notes for this agreement
                                </div>
                            }
                           <RenderAgreements/>

                        </div>
                    </div>

                </div>
            </ThemeProvider>
        </>
    )

}



const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", height: 'auto',
    marginTop: 5, paddingBottom: 3

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%',
    //  justifyContent: 'space-between',
    marginRight: 10
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%',
    // justifyContent: 'space-between',

}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
    width: "30%"
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}



export default AgreementNotes
